module.exports = __webpack_public_path__ + "4a0b0e438a8354a91ff196d15c5d12c6.woff2";